import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NeoDialogModule, NeoDialogRef } from '@neogov/pattern-library/neo-dialog';
import { ButtonComponent, IconComponent } from '@presentation/components';

export type AccessDeniedModalResult = 'go-home';

@Component({
  selector: 'cm-access-denied-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NeoDialogModule, ButtonComponent, IconComponent],
  templateUrl: './access-denied-modal.component.html',
  styleUrl: './access-denied-modal.component.less',
})
export class AccessDeniedModalComponent {
  private readonly _dialogRef = inject<NeoDialogRef<AccessDeniedModalComponent, AccessDeniedModalResult>>(NeoDialogRef);

  public onGoHome(): void {
    this._dialogRef.close('go-home');
  }
}
